import './App.css';
import Banner from './components/Banner';
import Header from './components/Header';
import About from './components/About';
import SearchForm from './components/SearchForm';

function App() {
  return (
    <>
      <Header/>
      <Banner/>
      <About/>
      <SearchForm/>
     
    </>
  );
}

export default App;
